/* ==========================================================================
   Customer Photo Grid — companion script for customer-photo-grid.css
   ========================================================================== */
(function () {
  'use strict';

  const SEE_MORE_CLASS = 'cpg-see-more';

  function tagGallery(gallery) {
    const links = gallery.querySelectorAll('.jdgm-gallery__thumbnail-link');
    for (let i = 0; i < links.length; i++) {
      const wrap = links[i].querySelector('.jdgm-gallery__thumbnail-wrapper');
      const label = wrap
        ? (window.getComputedStyle(wrap, '::before').content || '').toLowerCase()
        : '';
      const ellipsis = String.fromCharCode(0x2026);
      const isSeeMore = label.indexOf('more') !== -1 || label.indexOf(ellipsis) !== -1;
      links[i].classList.toggle(SEE_MORE_CLASS, isSeeMore);
    }
  }

  function run() {
    const galleries = document.querySelectorAll('.jdgm-gallery');
    for (let i = 0; i < galleries.length; i++) tagGallery(galleries[i]);
  }

  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }

  function init() {
    run();
    const host = document.querySelector('.jdgm-rev-widg') || document.body;
    new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();